<div id="content-section">
    <div id="content-main" class="responsive-content-main" [ngStyle]="{ 'margin-right': sidebarMaximized ? '370px' : '270px' }">
        <div id="content-sidebar" [ngClass]="{ 'responsive-content-sidebar': sidebarOpen, 'hide-responsive-sidebar': !sidebarOpen }" [ngStyle]="{ width: sidebarMaximized ? '350px' : '250px' }" style="position: fixed; right: 20px">
            <div class="sticky-top">
                <small class="bg-white">
                  <a href="#" class="d-none d-md-inline" [title]="sidebarMaximized ? 'Minimize Sidebar' : 'Maximize Sidebar'" (click)="sidebarMaximized = !sidebarMaximized; $event.preventDefault()">
                    <i class="fas" [ngClass]="{ 'fa-arrow-left': !sidebarMaximized, 'fa-arrow-right': sidebarMaximized }"></i>
                  </a>
                </small>
            </div>
            <div class="text-center pagination-small-margin pagination-center">
                <pagination
                    (pageChanged)="search($event, null)"
                    class="pagination-sm"
                    [boundaryLinks]="true"
                    [totalItems]="count"
                    [maxSize]="5"
                    [itemsPerPage]="searchParams.per_page"
                    [(ngModel)]="searchParams.page"
                    previousText="&lsaquo;"
                    nextText="&rsaquo;"
                    firstText="&laquo;"
                    lastText="&raquo;"
                ></pagination>
            </div>
            <div class="text-center pt-1">
                <app-pagination-count
                    [count]="count"
                    singularName="Billing"
                    pluralName="Billings"
                ></app-pagination-count>
            </div>
            <hr class="my-1" />
            <div class="clearfix"></div>
            <div class="sticky-top bg-white">
                <h5 class="pt-2">
                <div class="pull-right float-right">
                    <app-clear-search-btn [searching]="searching" (onClick)="clearSearch()"></app-clear-search-btn>
                </div>
                <span>
                    Search&nbsp;&nbsp;
                    <a href="javascript: void(0)" title="Search" style="cursor: pointer" (click)="!searching ? (searchParams.page = 1) && search(null, true) : ''">
                        <i *ngIf="!searching" class="fas fa-arrow-circle-right"></i><i *ngIf="searching" class="fas fa-spinner fa-pulse fa-fw"></i>
                    </a>
                </span>
                </h5>
                <hr class="my-1" />
            </div>
            <div class="row">
                <div class="col-md-12">
                    <form>
                        <div class="form-group">
                            <label for="bill-type">Bill type:</label>
                            <select class="form-control" id="bill-type" [(ngModel)]="searchParams['search[bill_type_id]']" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                                <option [value]=""></option>
                                <option [value]="billType.value" *ngFor="let billType of searchOptions.bill_types">{{billType.label}}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="billing-user">Billing User:</label>
                            <select class="form-control" id="billing-user" [(ngModel)]="searchParams.user_id" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                                <option [value]=""></option>
                                <option [value]="billUser.value" *ngFor="let billUser of searchOptions.bill_users">{{billUser.label}}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="bill-id">Bill ID:</label>
                            <input class="form-control" type="number" id="bill-id" name="bill-id" [(ngModel)]="searchParams.bill_id" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                        </div>
                        <div class="form-group">
                            <label for="matter-name">Matter Name/Number:</label>
                            <app-matter-search id="matter-name" [placeholder]="'Search and select'" [small_input]="false" (clearMatter)="this.searchParams.matter_id = undefined" (matter_id)="this.searchParams.matter_id = $event"></app-matter-search>
                        </div>
                        <div class="form-group">
                            <label for="amount">Amount:</label>
                            <input class="form-control" type="number" id="amount" name="amount" [(ngModel)]="searchParams.amount" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                        </div>
                        <div class="form-group">
                            <label for="rate">Rate:</label>
                            <input class="form-control" type="number" id="rate" name="rate" [(ngModel)]="searchParams.rate" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                        </div>
                        <div class="form-group">
                            <label for="quantity">Quantity:</label>
                            <input class="form-control" type="number" id="quantity" name="quantity" [(ngModel)]="searchParams.quantity" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-6">
                                <label for="from-date">Date From:</label>
                                <input type="text" class="form-control" #FilterFromDate="ngModel" name="from-date" [(ngModel)]="searchParams.date_from" placeholder="Click to select date" [appDatepicker]="" (dateSelected)="searchParams.date_from = $event" id="fromDate" />
                            </div>
                            <div class="form-group col-md-6">
                                <label for="to-date">Date To:</label>
                                <input type="text" class="form-control" #FilterToDate="ngModel" name="to-date" [(ngModel)]="searchParams.date_to" placeholder="Click to select date" [appDatepicker]="" (dateSelected)="searchParams.date_to = $event" id="toDate" />
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-6">
                                <label for="billability">Billability:</label>
                                <select class="form-control" id="billability" [(ngModel)]="searchParams.is_billable" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                                    <option [value]=""></option>
                                    <option [value]="1">Billable</option>
                                    <option [value]="0">Not Billable</option>
                                </select>
                            </div>
                            <div class="form-group col-md-6">
                                <label for="authorization">Authorization:</label>
                                <select class="form-control" id="authorization" [(ngModel)]="searchParams.is_authorized" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                                    <option [value]=""></option>
                                    <option [value]="1">Authorized</option>
                                    <option [value]="0">Not Authorized</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-6">
                                <label for="order-by">Order By:</label>
                                <select class="form-control" id="order-by" [(ngModel)]="searchParams.order_by" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                                    <option [value]=""></option>
                                    <option [value]="orderBy.value" *ngFor="let orderBy of searchOptions.order_by">{{orderBy.label}}</option>
                                </select>
                            </div>
                            <div class="form-group col-md-6">
                                <label for="in-order-of">In Order Of:</label>
                                <select class="form-control" id="in-order-of" [(ngModel)]="searchParams.order_direction" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                                    <option [value]=""></option>
                                    <option [value]="orderDirection.value" *ngFor="let orderDirection of searchOptions.order_direction">{{orderDirection.label}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group form-check">
                            <input type="checkbox" class="form-check-input" id="weekly-fees" [(ngModel)]="searchParams['search[weekly_fees]']" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                            <label class="form-check-label" for="weekly-fees">User's Weekly Fees</label>
                        </div>
                        <div class="form-group form-check">
                            <input type="checkbox" class="form-check-input" id="others-billings" [(ngModel)]="searchParams['search[others_billings]']" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                            <label class="form-check-label" for="others-billings">Others Billings for User's Matters</label>
                        </div>
                        <div class="form-group">
                            <app-button (onClick)="searchParams.page = 1; search(null, true)" [small]="true" style="width: 100%" [disabled]="searching">
                                Search
                                <span *ngIf="searching">
                                    &nbsp;
                                    <i class="fas fa-spinner fa-pulse fa-fw"></i>
                                </span>
                            </app-button>
                        </div>
                    </form>
                    <h4>
                        Value:&nbsp;
                        <app-badge badgeType="info">
                            {{total | currency: 'USD':'symbol':'1.2-2'}}
                        </app-badge>
                    </h4>
                    <h4>
                        Total Time:&nbsp;
                        <app-badge badgeType="secondary">
                            {{hours}}
                        </app-badge>
                    </h4>
                    <h4>
                        Billable:&nbsp;
                        <app-badge badgeType="info">
                            {{billable | currency: 'USD':'symbol':'1.2-2'}}
                        </app-badge>
                    </h4>
                </div>
            </div>
        </div>
        <div id="content-inner" class="responsive-content-inner" style="padding: 0px 20px 10px 20px">
            <div class="container-shadow px-3 pb-4">
                <h2 class="pt-4 text-center">Billings</h2>
                <hr class="mt-1 mb-2" />
                <div class="row p-4" style="overflow-x:auto;transform: rotateX(180deg);">
                    <table class="table table-striped" style="transform: rotateX(180deg);">
                        <thead>
                            <tr>
                                <th></th>
                                <th>ID</th>
                                <th>Activity</th>
                                <th>Matter</th>
                                <th>Attorney</th>
                                <th>Bill ID</th>
                                <th>Description</th>
                                <th>Date</th>
                                <th class="text-right">Rate</th>
                                <th>Time</th>
                                <th class="text-right">Fee</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let billing of billings">
                                <td><img [src]="billing.status_icon_url" alt="..."></td>
                                <td><a [href]="'/billings/' + billing.id">{{billing.id}}</a></td>
                                <td>{{billing.activity.name}}</td>
                                <td><a [routerLink]="'/matters/' + billing.matter_id">{{billing.matter.number}}</a></td>
                                <td>{{billing.attorney}}</td>
                                <td><a [href]="'/bills/' + billing.bill_id">{{billing.bill_id}}</a></td>
                                <td>{{billing.description}}</td>
                                <td>{{billing.formatted_date}}</td>
                                <td class="text-right">{{billing.rate}}</td>
                                <td>{{billing.time}}</td>
                                <td class="text-right">
                                    <span *ngIf="billing.fee">{{billing.fee | currency: 'USD':'symbol':'1.2-2'}}</span>
                                    <span *ngIf="!billing.fee"></span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
<app-sidebar-toggle-btn [sidebarOpen]="sidebarOpen" (onClick)="sidebarOpen = !sidebarOpen"></app-sidebar-toggle-btn>